import ShiftkeyComplete from '@/assets/images/shiftkey-complete.svg?react'
import ShiftkeyLogo from '@/assets/images/shiftkey-logo.svg?react'

type Theme = {
  [key: string]: string
}

const theme: { [key: string]: Theme } = {
  SHIFTKEY_WALLET: {
    background: `bg-shiftkeyBG bg-contain`,
    body: 'bg-shiftkey-background',
    footer: 'bg-shiftkey-footer text-gray-500 rounded-t-3xl',
    logo: `${ShiftkeyLogo}`,
    button: 'bg-shiftkey-primary',
    accountCreatedIcon: `${ShiftkeyComplete}`,
  },
  default: {
    background: `before:absolute before:content-[''] before:bg-appBG before:bg-no-repeat before:bg-contain before:w-[48%] before:h-[90%] before:-top-16 before:left-2/4 before:-translate-x-[105%] before:bg-right before:min-h-[665px] before:min-w-[440px]`,
    contentBackground: 'bg-[#d9ffe7] rounded-3xl',
    body: 'bg-white',
    footer: 'bg-white text-gray-500',
    button: 'bg-green-500',
  },
}

export const getOrgTheme = (orgId?: string) => {
  if (!orgId) return theme.default
  if (!theme[orgId]) return theme.default
  return theme[orgId]
}
